import { useCancelBroadbandForm } from "@features/CancelBroadband/CancelBroadbandForm/useCancelBroadbandForm";
import { CancelBroadbandReasons } from "@features/CancelBroadband/CancelBroadbandForm/CancelBroadbandReasons/CancelBroadbandReasons";
import { CancelBroadbandDetails } from "@features/CancelBroadband/CancelBroadbandForm/CancelBroadbandDetails/CancelBroadbandDetails";

interface IParams {
    getTerminationRequest(): void;
}

export const CancelBroadbandForm = (props: IParams) => {
    const { getTerminationRequest } = props;

    const {
        reasonsSubmitted,
        handleSubmitReasons,
        cancelBroadbandForm,
        cancelBroadbandValues,
    } = useCancelBroadbandForm();

    if (!reasonsSubmitted) {
        return <CancelBroadbandReasons cancelBroadbandForm={cancelBroadbandForm} onSubmit={handleSubmitReasons} />;
    }

    return <CancelBroadbandDetails formData={cancelBroadbandValues} getTerminationRequest={getTerminationRequest} />;
};
